/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Label_ToneInputs */

const en_cover_letters_label_tone = /** @type {(inputs: Cover_Letters_Label_ToneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tone`)
};

const de_cover_letters_label_tone = /** @type {(inputs: Cover_Letters_Label_ToneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tonalität`)
};

const fr_cover_letters_label_tone = /** @type {(inputs: Cover_Letters_Label_ToneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton`)
};

const es_cover_letters_label_tone = /** @type {(inputs: Cover_Letters_Label_ToneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tono`)
};

const it_cover_letters_label_tone = /** @type {(inputs: Cover_Letters_Label_ToneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tono`)
};

const nl_cover_letters_label_tone = /** @type {(inputs: Cover_Letters_Label_ToneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toon`)
};

const pl_cover_letters_label_tone = /** @type {(inputs: Cover_Letters_Label_ToneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton`)
};

const fi_cover_letters_label_tone = /** @type {(inputs: Cover_Letters_Label_ToneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sävy`)
};

const da_cover_letters_label_tone = /** @type {(inputs: Cover_Letters_Label_ToneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tone`)
};

const sv_cover_letters_label_tone = /** @type {(inputs: Cover_Letters_Label_ToneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton`)
};

/**
* | output |
* | --- |
* | "Tone" |
*
* @param {Cover_Letters_Label_ToneInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_label_tone = /** @type {((inputs?: Cover_Letters_Label_ToneInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Label_ToneInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_label_tone(inputs)
	if (locale === "fr") return fr_cover_letters_label_tone(inputs)
	if (locale === "es") return es_cover_letters_label_tone(inputs)
	if (locale === "it") return it_cover_letters_label_tone(inputs)
	if (locale === "nl") return nl_cover_letters_label_tone(inputs)
	if (locale === "pl") return pl_cover_letters_label_tone(inputs)
	if (locale === "fi") return fi_cover_letters_label_tone(inputs)
	if (locale === "da") return da_cover_letters_label_tone(inputs)
	if (locale === "sv") return sv_cover_letters_label_tone(inputs)
	return en_cover_letters_label_tone(inputs)
});